import { createRoutine } from 'redux-saga-routines'

export const SET = 'STATIC_CONTENTS/SET'
export const GET_RESOURCES = createRoutine('STATIC_CONTENTS/GET_RESOURCES')
export const RESET = 'STATIC_CONTENTS/RESET'
